import { render, staticRenderFns } from "./ProfileCard.vue?vue&type=template&id=6e6b66dd&scoped=true"
import script from "./ProfileCard.vue?vue&type=script&lang=js"
export * from "./ProfileCard.vue?vue&type=script&lang=js"
import style0 from "./ProfileCard.vue?vue&type=style&index=0&id=6e6b66dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6b66dd",
  null
  
)

export default component.exports